<template>
    <!-- Tooltip message -->
  <div data-type="AI Icon Flyout"
  :class="[
    'mt-2 p-3 relative shadow-[0px_4px_4px_0px_rgba(0,0,0,0.20)] inline-flex justify-start items-start gap-2 border border-[#8B84D7] bg-white rounded-md',
    isMobileBreakpoint ? 'w-[96%]' : 'w-80'
  ]"
  >
   
     
    <!-- Triangle with only border color (no fill) -->
<div class="absolute -top-2 left-4 w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[8px] border-b-white z-10"></div>
<div class="absolute -top-[9px] left-4 w-0 h-0 border-l-[9px] border-l-transparent border-r-[9px] border-r-transparent border-b-[9px] border-b-[#8B84D7] z-0"></div>

    <!-- Tooltip Content -->
    <div class="flex-1 justify-start text-neutral-900 text-sm font-normal font-visuelt leading-tight">
        Hi! I'm Taia, your AI Wellness Advisor. I'm created by Thorne's science and medical teams. Ask me about your health goals or Thorne products, and I'll provide you with personalized recommendations.
    </div>

    <!-- Close Icon -->
    <button @click="close" class="w-4 h-4 inline-flex flex-col justify-center items-center gap-2.5 cursor-pointer">
       <img :src="xmark"></img>
    </button>
</div>

</template>

<script setup lang="ts">
import { defineEmits } from 'vue';
import xmark from '@/assets/tgpt/images/xmark.png'
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import eventBusGtm from '@/composables/eventBusGtm';


const breakPoints = useBreakpoints(breakpointsTailwind);

const isMobileBreakpoint = breakPoints.smaller('md');


// Define the close event that will be emitted
const emit = defineEmits<{
    (e: 'close'): void;
}>();

// Function to emit the close event
const close = () => {
  const screenName = document.title;
 eventBusGtm.emit('trackEvent', {
    event: 'Taia',
    button_name: 'flyout_dismissal',
    screen_name: screenName,
  });
  
  emit('close'); // Emit the 'close' event to the parent
};
</script>